module.exports = __webpack_public_path__ + "static/img/6_10commitments_200sites.00a3c02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/6_10commitments_200sites.jpg
// module id = 1N5k
// module chunks = 0